---
label: Features
category: sequences
icon: TagIcon
keywords: [feature, annotation, cds, gene, qualifier, segment, strand]
addedInVersion: "0.0.0"
---

# Features

Features are annotations on a sequence — genes, CDS, promoters, UTRs, and more.

## Adding Features

Select a region on the sequence, then click **Create feature** in the toolbar or
right-click and choose **Create feature**. The selected range is pre-filled in
the creation dialog.

You can also import features in bulk from GenBank or GFF files using the
**Import features** button in the toolbar.

## Segments

A feature can span multiple non-contiguous regions (joins). For example, a gene
with three exons would have three segments. Add or remove segments in the
creation dialog or the feature details sheet.

## Qualifiers

Qualifiers are key-value metadata on a feature, like `/gene="rpoB"` or
`/product="RNA polymerase"`. They come from standard GenBank annotation
conventions. Add or edit qualifiers in the feature details sheet.

## Strand and Range

Each feature has a strand (forward or reverse) and one or more segments defined
by start and end positions. Positions are 1-based and inclusive.

## Editing

Click a feature row in the **Features** tab to open its details sheet. From
there you can change the name, type, strand, segments, and qualifiers. Name and
type can also be edited inline in the table.

You can also right-click a feature on the sequence canvas and choose **Edit**.

## Copying and Extracting

Click a feature on the sequence canvas to see its actions. **Copy nucleotides**
copies the feature's nucleotide sequence to the clipboard. For CDS features with
a translation, **Copy translation** copies the amino acid sequence.

**Extract** creates a new sequence file from the feature's nucleotide range,
including its annotation data.

## Deleting

Delete a single feature from its details sheet or right-click popover. For bulk
deletion, select features using checkboxes in the Features tab and click
**Delete**.
